"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
// Getting Site Name with browser default props
var getSiteName = function () {
    var locationHostname = (0, utils_1.removeSpecialCharacters)(window.location.hostname) || "";
    if (locationHostname.match(/^www\.(.*)(\.com|\.org)$/) !== null) {
        return locationHostname
            .match(/^www\.(.*)(\.com|\.org)$/)[1]
            .replace(".", "-");
    }
    else {
        var getSite = locationHostname.match(/(.*)(\.com|\.org)$/);
        if (getSite && getSite[1].split(".")[0] === "my") {
            return "".concat(getSite[1].split(".")[1], "-mypmi");
        }
        else if (getSite) {
            return "".concat(getSite[1].split(".")[1], "-").concat(getSite[1].split(".")[0]);
        }
    }
    return "pmi";
};
exports.default = getSiteName;
